<div
  class="mb-4 flex flex-col gap-2 rounded-lg border border-gray-200 bg-white p-6 filters-shadow"
  (click)="onContainerClick($event)">
  <div class="border-border grid grid-cols-2 gap-6 border-b pb-6">
    <app-filter-input
      [label]="isArabic() ? 'رقم الطلب' : 'Search by Order ID'"
      [placeholder]="isArabic() ? 'البحث برقم الطلب...' : 'Search by order ID'"
      type="number"
      [(value)]="orderId"></app-filter-input>

    <app-filter-select-component
      [label]="isArabic() ? 'الحالة' : 'Status'"
      [defaultOption]="isArabic() ? 'كل الحالات' : 'All Statuses'"
      [options]="statusOptions()"
      [(value)]="selectedStatusId"></app-filter-select-component>

    <app-filter-date-component
      [label]="isArabic() ? 'تاريخ الإنشاء (من)' : 'Order Date From'"
      [value]="createdOnFrom()"
      (valueChange)="createdOnFrom.set($event)"
      [isInvalid]="createdDateInvalid()"></app-filter-date-component>

    <app-filter-date-component
      [label]="isArabic() ? 'تاريخ الإنشاء (إلى)' : 'Order Date To'"
      [value]="createdOnTo()"
      (valueChange)="createdOnTo.set($event)"
      [isInvalid]="createdDateInvalid()"></app-filter-date-component>

    <app-filter-date-component
      [label]="isArabic() ? 'آخر تعديل (من)' : 'Last Modified From'"
      [value]="lastModifiedOnFrom()"
      (valueChange)="lastModifiedOnFrom.set($event)"
      [isInvalid]="lastModifiedDateInvalid()"></app-filter-date-component>

    <app-filter-date-component
      [label]="isArabic() ? 'آخر تعديل (إلى)' : 'Last Modified To'"
      [value]="lastModifiedOnTo()"
      (valueChange)="lastModifiedOnTo.set($event)"
      [isInvalid]="lastModifiedDateInvalid()"></app-filter-date-component>
  </div>

  <div class="flex justify-end gap-3 pt-4">
    <button
      (click)="onResetFilters()"
      class="border-primary text-primary hover-bg-primary-10 rounded-[6px] border px-5 py-1.5 text-[13px] font-[500] hover:cursor-pointer">
      <span i18n="@@adminOrdersResetButton">Clear</span>
    </button>
    <button
      (click)="onApplyFilters()"
      class="bg-primary hover-bg-primary-hover rounded-[6px] px-5 py-1.5 text-[13px] font-[500] text-white hover:cursor-pointer">
      <span i18n="@@adminOrdersApplyButton">Apply</span>
    </button>
  </div>
</div>
